import React, {
  Component
} from 'react';
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from 'semantic-ui-react';

class NotFoundView extends Component {

  constructor (props) {
    super(props);
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Grid doubling columns={2} centered>
          <Grid.Column>
            <Segment textAlign="center" color="red">
              <Header as="h2">
                404 - RUTA INEXISTENTE!
              </Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default NotFoundView;



// WEBPACK FOOTER //
// ./client/components/pages/NotFoundView.js